export const tillMapper = {
  mapTips(data) {
    const mappedData = {
      ...data,
      cash: Number(data.cash),
      tpv: Number(data.tpv),
      others: Number(data.others),
      total: Number(data.total)
    };
    return mappedData;
  },
  mapPayments(data) {
    const mappedData = {
      ...data,
      cash: Number(data.cash),
      debit: Number(data.debit),
      visa: Number(data.visa),
      master: Number(data.master),
      certificat: Number(data.certificat),
      client: Number(data.client),
      others: Number(data.others)
    };
    return mappedData;
  },
  mapTill(data) {
    const mappedData = {
      ...data
    };
    if (mappedData.tips) {
      mappedData.tips = this.mapTips(mappedData.tips);
    }
    if (mappedData.payments) {
      mappedData.payments = this.mapPayments(mappedData.payments);
    }
    return mappedData;
  }
};
